export const notificationProviderKeyEnum = Object.freeze({
  NOTIFICATION_SETTING_MODEL: Symbol(),
  ON_UNSUBSCRIBE: Symbol(),
});
